import { classes } from 'html-classes';
import { AnyMasked, IMaskInput } from 'react-imask';

import { OTP_MASK } from '../../constants';

import styles from './OtpInput.module.scss';

/**
 * Props for the OtpInput component.
 */
interface OtpInputProps {
  /** Current OTP code value */
  value: string;
  /** Callback fired when OTP value changes, includes completion status */
  onChange: (value: string, isComplete: boolean) => void;
  /** Error message to display below the input */
  error?: string;
  /** Whether to auto-focus the input on mount */
  autoFocus?: boolean;
}

/**
 * Masked input component for entering OTP verification codes.
 * Uses input masking to ensure proper digit format.
 */
const OtpInput = ({
  value,
  onChange,
  error,
  autoFocus = true,
}: OtpInputProps) => {
  const handleAccept = (val: string, mask: AnyMasked) => {
    onChange(val, mask.masked.isComplete);
  };

  return (
    <div className={styles.root}>
      <IMaskInput
        className={classes([styles.input, error && styles.hasError])}
        mask={OTP_MASK}
        value={value}
        unmask={true}
        type="tel"
        autoFocus={autoFocus}
        onAccept={handleAccept}
        autoComplete="one-time-code"
        placeholder={OTP_MASK}
        data-input="otp-code"
      />
      {error && <div className={styles.error}>{error}</div>}
    </div>
  );
};

OtpInput.displayName = 'OtpInput';

export default OtpInput;
